import { Button } from "@/components/ui/button";
import {
  Home,
  User,
  Ellipsis,
  Wallet,
  Ticket,
  ChevronLeft,
  Bell,
  Gift,
} from "lucide-react";
import { Link, NavLink, Outlet, useLocation, useNavigate } from "react-router";
import { useHeader } from "@/hooks/useHeader.ts";
import { useClient } from "@/hooks/useClient.ts";
import { cn } from "@/lib/utils.ts";
import { usePrizeCompetition } from "@/hooks/usePrizeCompetition.ts";
import { useTranslation } from "@/i18n";

const MainPages = ["/", "/wallet", "/tickets", "/free-ticket", "/more"];

const MobileLayout = () => {
  const location = useLocation();
  const isMainPage = MainPages.includes(location.pathname);
  const header = useHeader();
  const client = useClient();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { claimInstruction } = usePrizeCompetition();

  return (
    <div className="flex h-screen flex-col">
      <header className="bg-primary text-primary-foreground flex items-center justify-between border-b p-4">
        {!isMainPage && (
          <Button
            variant="ghost"
            size="content"
            className="flex-1"
            onClick={() => navigate(-1)}
          >
            <ChevronLeft className="size-8" />
          </Button>
        )}

        {isMainPage && (
          <>
            <Link to="/notifications" className="flex-1">
              <Button variant="ghost" size="content">
                <Bell className="size-8" />
              </Button>
            </Link>
            <img
              className="h-10 object-contain"
              src={client!.logo_url}
              alt={client!.name}
            />
          </>
        )}

        {!isMainPage && <h1 className="w-full text-xl">{header.title}</h1>}
        <Link
          to="/profile"
          className={cn("flex flex-1 justify-end", !isMainPage && "invisible")}
        >
          <Button variant="ghost" size="content">
            <User className="size-8" />
          </Button>
        </Link>
      </header>

      <main className="bg-background flex-1 overflow-y-auto p-4">
        <Outlet />
      </main>

      {isMainPage && (
        <nav className="bg-card flex justify-around border-t">
          <NavLink
            to="/"
            className={({ isActive }) => cn(isActive && "text-secondary")}
          >
            <Button
              variant="ghost"
              size="content"
              className="flex flex-col p-2 font-bold"
            >
              <Home className="size-6" />
              <span className="text-xs">{t("nav.raffles")}</span>
            </Button>
          </NavLink>
          <NavLink
            to="/wallet"
            className={({ isActive }) => cn(isActive && "text-secondary")}
          >
            <Button
              variant="ghost"
              size="content"
              className="flex flex-col p-2"
            >
              <Wallet className="size-6" />
              <span className="text-xs">{t("nav.wallet")}</span>
            </Button>
          </NavLink>
          <NavLink
            to="/tickets"
            className={({ isActive }) => cn(isActive && "text-secondary")}
          >
            <Button
              variant="ghost"
              size="content"
              className="flex flex-col p-2"
            >
              <Ticket className="size-6" />
              <span className="text-xs">{t("nav.tickets")}</span>
            </Button>
          </NavLink>
          {!!claimInstruction && (
            <NavLink
              to="/free-ticket"
              className={({ isActive }) => cn(isActive && "text-secondary")}
            >
              <Button
                variant="ghost"
                size="content"
                className="flex flex-col p-2"
              >
                <Gift className="size-6" />
                <span className="text-xs">{t("nav.freeTicket")}</span>
              </Button>
            </NavLink>
          )}
          <NavLink
            to="/more"
            className={({ isActive }) => cn(isActive && "text-secondary")}
          >
            <Button
              variant="ghost"
              size="content"
              className="flex flex-col p-2"
            >
              <Ellipsis className="size-6" />
              <span className="text-xs">{t("nav.more")}</span>
            </Button>
          </NavLink>
        </nav>
      )}
    </div>
  );
};

export default MobileLayout;
